// extracted by mini-css-extract-plugin
module.exports = {"slide":"providers-preview_slide__4VKsN","providers_list":"providers-preview_providers_list__Wwx_E","menu_providers":"providers-preview_menu_providers__SPKh0"};